import Vue from 'vue'
import Router from 'vue-router'
import { SUPER_PATHS, GUILD_PATHS } from '../config'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/login', component: () => import('../views/Login.vue'), meta: { noAuth: true } },
    { path: '/', redirect: '/dashboard' },
    { path: '/dashboard', component: () => import('../views/Dashboard.vue') },
    { path: '/user-distribution', component: () => import('../views/UserDistribution.vue') },
    { path: '/revenue-guide', component: () => import('../views/RevenueGuide.vue') },
    { path: '/users', component: () => import('../views/Users.vue') },
    { path: '/rooms', component: () => import('../views/Rooms.vue') },
    { path: '/guilds', component: () => import('../views/Guilds.vue') },
    { path: '/mall', component: () => import('../views/Mall.vue') },
    { path: '/decorations', component: () => import('../views/Decorations.vue') },
    { path: '/gifts', component: () => import('../views/Gifts.vue') },
    { path: '/vip', component: () => import('../views/Vip.vue') },
    { path: '/recharge', component: () => import('../views/Recharge.vue') },
    { path: '/rank', component: () => import('../views/Rank.vue') },
    { path: '/withdraw', component: () => import('../views/WithdrawLogs.vue') },
    { path: '/finance', component: () => import('../views/FinanceReport.vue') },
    { path: '/revenue-board', component: () => import('../views/RevenueBoard.vue') },
    { path: '/organizations', component: () => import('../views/Organizations.vue') },
    { path: '/trtc-accounts', component: () => import('../views/TrtcAccounts.vue') },
    { path: '/audit-logs', component: () => import('../views/AuditLogs.vue') },
    { path: '/feature-analytics', component: () => import('../views/FeatureAnalytics.vue') },
    { path: '/org-rewards', component: () => import('../views/OrgRewards.vue') },
    { path: '/org-reward-logs', component: () => import('../views/OrgRewardLogs.vue') },
    { path: '/assist-dashboard', component: () => import('../views/AssistDashboard.vue') },
    { path: '/assist-activities', component: () => import('../views/AssistActivities.vue') },
    { path: '/assist-records', component: () => import('../views/AssistRecords.vue') },
    { path: '/assist-blacklist', component: () => import('../views/AssistBlacklist.vue') },
    { path: '/settings/basic', component: () => import('../views/SettingsBasic.vue') },
    { path: '/settings/exchange', component: () => import('../views/SettingsExchange.vue') },
    { path: '/settings/agreements', component: () => import('../views/SettingsAgreements.vue') },
    { path: '/settings/payment', component: () => import('../views/SettingsPayment.vue') },
  ],
})

// 路由守卫：未登录跳转登录页；按身份拦截越权页面（URL 直闯防御）
// 身份缓存 admin_scope：super / org / guild / none（由 App.vue checkOrg 写入）
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (to.meta.noAuth) {
    next()
  } else if (!token) {
    next('/login')
  } else if (SUPER_PATHS.has(to.path) && localStorage.getItem('admin_is_super') !== 'true') {
    // 前端只做体验层拦截；后端 superAdmin 中间件才是真正的权限闸门
    next('/dashboard')
  } else if (localStorage.getItem('admin_scope') === 'guild' && !GUILD_PATHS.has(to.path)) {
    // 公会创作者：仅可访问公会管理（后端按 leader_id 强制过滤数据）
    next('/guilds')
  } else {
    next()
  }
})

export default router
